import { createRouter, createWebHistory } from 'vue-router';

const routes = [
    {
        path: '/random',
        name: 'randomComic',
        component: () => import('@/views/randomComic/randomComic'),
    },
    {
        path: '/comicList',
        name: 'comicList',
        component: () => import('@/views/comicList/comicList'),
    },
    {
        path: '/feedback',
        name: 'feedback',
        component: () => import('@/views/feedback/userHelp'),
    },
    {
        path: '/subPlan',
        name: 'subPlan',
        component: () => import('@/views/subInfo/subPlan'),
    },
    {
        path: '/feed_back',
        name: 'feed_back',
        component: () => import('@/views/feedback/userHelpV2'),
    },
    {
        path: '/upload/:token',
        name: 'comicUpload',
        component: () => import('@/views/upload/comicUpload'),
    },
    {
        path: '/uploadStar/:token',
        name: 'uploadStar',
        component: () => import('@/views/upload/uploadStar'),
    },
    {
        path: '/report/:id/:token',
        name: 'reportMsg',
        component: () => import('@/views/video/reportMsg'),
    },
    {
        path: '/comicReport/:id/:token',
        name: 'comicReport',
        component: () => import('@/views/comic/comicReport'),
    },
    {
        path: '/banner',
        name: 'banner',
        component: () => import('@/views/banner/bannerIndex'),
    },
    {
        path: '/epiSelectA/:sty',
        name: 'epiSelectA',
        component: () => import('@/views/newP/epiSelectA'),
    },
    {
        path: '/selectP/:sty',
        name: 'selectP',
        component: () => import('@/views/newP/selectP'),
    },
    {
        path: '/selectA/:sty',
        name: 'selectA',
        component: () => import('@/views/newP/selectA'),
    },
    {
        path: '/selectW/:sty',
        name: 'selectW',
        component: () => import('@/views/newP/selectW'),
    },
    {
        path: '/selectX/:sty',
        name: 'selectX',
        component: () => import('@/views/newP/selectX'),
    },

    {
        path: '/payMenu',
        name: 'payMenu',
        component: () => import('@/views/pay/payMenu'),
    },
    {
        path: '/paySucc/:token',
        name: 'paySucc',
        component: () => import('@/views/pay/paySucc'),
    },
    {
        path: '/payCancel/:token',
        name: 'payCancel',
        component: () => import('@/views/pay/payCancel'),
    },
    {
        path: '/webPay/:token',
        name: 'webPay',
        component: () => import('@/views/web_pay/webPay'),
    },
    {
        path: '/webPayCancel/:token',
        name: 'webPayCancel',
        component: () => import('@/views/web_pay/payCancel'),
    },

    /* art stp */
    {
        path: '/artMenu/:dis_tm',
        name: 'artMenu',
        component: () => import('@/views/artavo/artMenu'),
    },
    {
        path: '/artSucc/:token',
        name: 'artSucc',
        component: () => import('@/views/artavo/artSucc'),
    },
    {
        path: '/artCancel/:token',
        name: 'artCancel',
        component: () => import('@/views/artavo/artCancel'),
    },

    /* art air */
    {
        path: '/aArtMenu/:dis_tm',
        name: 'aArtMenu',
        component: () => import('@/views/aArt/aArtMenu'),
    },
    {
        path: '/aArtSucc/:token',
        name: 'aArtSucc',
        component: () => import('@/views/aArt/aArtSucc'),
    },
    {
        path: '/aArtCancel/:token',
        name: 'aArtCancel',
        component: () => import('@/views/aArt/aArtCancel'),
    },


    /* ms stp */
    {
        path: '/webMenu/:dis_tm',
        name: 'webMenu',
        component: () => import('@/views/mospix/webMenu'),
    },
    {
        path: '/webSucc/:is_life/:token',
        name: 'webSucc',
        component: () => import('@/views/mospix/webSucc'),
    },
    {
        path: '/webCancel/:token',
        name: 'webCancel',
        component: () => import('@/views/mospix/webCancel'),
    },
    /* ms air */
    {
        path: '/aWebMenu/:dis_tm',
        name: 'aWebMenu',
        component: () => import('@/views/aMospix/aWebMenu'),
    },
    {
        path: '/aWebSucc/:is_life/:token',
        name: 'aWebSucc',
        component: () => import('@/views/aMospix/aWebSucc'),
    },
    {
        path: '/aWebCancel/:token',
        name: 'aWebCancel',
        component: () => import('@/views/aMospix/aWebCancel'),
    },

    {
        path: '/webAndSucc/:token',
        name: 'webAndSucc',
        component: () => import('@/views/pay/webSucc'),
    },
    {
        path: '/webAndCancel/:token',
        name: 'webAndCancel',
        component: () => import('@/views/pay/webCancel'),
    },

    /* mb air */
    {
        path: '/aMbMenu/:pay_id/:token',
        name: 'aMbMenu',
        component: () => import('@/views/aMb/aMbMenu'),
    },
    {
        path: '/aMbList/:dis_tm',
        name: 'aMbList',
        component: () => import('@/views/aMb/aMbList'),
    },

    /* mb stp */
    {
        path: '/mbList/:dis_tm',
        name: 'mbList',
        component: () => import('@/views/mb/mbList'),
    },
    {
        path: '/mbSucc/:token',
        name: 'mbSucc',
        component: () => import('@/views/mb/mbSucc'),
    },
    {
        path: '/mbCancel/:token',
        name: 'mbCancel',
        component: () => import('@/views/mb/mbCancel'),
    },


    /* pco stp */
    {
        path: '/pcoMenu/:dis_tm',
        name: 'pcoMenu',
        component: () => import('@/views/pco/pcoMenu'),
    },
    {
        path: '/pcoSucc/:token',
        name: 'pcoSucc',
        component: () => import('@/views/pco/pcoSucc'),
    },
    {
        path: '/pcoCancel/:token',
        name: 'pcoCancel',
        component: () => import('@/views/pco/pcoCancel'),
    },

    /* pco air */
    {
        path: '/aPcoMenu/:dis_tm',
        name: 'aPcoMenu',
        component: () => import('@/views/aPco/aPcoMenu'),
    },
    {
        path: '/aPcoSucc/:token',
        name: 'aPcoSucc',
        component: () => import('@/views/aPco/aPcoSucc'),
    },
    {
        path: '/wafSucc/:token',
        name: 'wafSucc',
        component: () => import('@/views/wafPay/wafSucc'),
    },
    {
        path: '/aPcoCancel/:token',
        name: 'aPcoCancel',
        component: () => import('@/views/aPco/aPcoCancel'),
    },

    /* ink stp */
    {
        path: '/inkMenu/:dis_tm',
        name: 'inkMenu',
        component: () => import('@/views/pco/inkMenu'),
    },
    /* ink air */
    {
        path: '/aInkMenu/:dis_tm',
        name: 'aInkMenu',
        component: () => import('@/views/aPco/aInkMenu'),
    },


    /* cov stp */
    {
        path: '/covMenu/:dis_tm',
        name: 'covMenu',
        component: () => import('@/views/cov/covMenu'),
    },
    {
        path: '/covSucc/:is_life/:token',
        name: 'covSucc',
        component: () => import('@/views/cov/covSucc'),
    },
    {
        path: '/covCancel/:token',
        name: 'covCancel',
        component: () => import('@/views/cov/covCancel'),
    },
    {
        path: '/epiMenu/:dis_tm',
        name: 'epiMenu',
        component: () => import('@/views/cov/epiMenu'),
    },


    /* cov air */
    {
        path: '/aCovMenu/:dis_tm',
        name: 'aCovMenu',
        component: () => import('@/views/aCov/aCovMenu'),
    },
    {
        path: '/aCovSucc/:is_life/:token',
        name: 'aCovSucc',
        component: () => import('@/views/aCov/aCovSucc'),
    },
    {
        path: '/aCovCancel/:token',
        name: 'aCovCancel',
        component: () => import('@/views/aCov/aCovCancel'),
    },
    {
        path: '/aEpiMenu/:dis_tm',
        name: 'aEpiMenu',
        component: () => import('@/views/aCov/aEpiMenu'),
    },




    /* gap stp */
    {
        path: '/gapMenu/:dis_tm',
        name: 'gapMenu',
        component: () => import('@/views/gap/gapMenu'),
    },
    {
        path: '/gapSucc/:token',
        name: 'gapSucc',
        component: () => import('@/views/gap/gapSucc'),
    },
    {
        path: '/gapCancel/:token',
        name: 'gapCancel',
        component: () => import('@/views/gap/gapCancel'),
    },

    /* gap air */
    {
        path: '/aGapMenu/:dis_tm',
        name: 'aGapMenu',
        component: () => import('@/views/aGap/aGapMenu'),
    },
    {
        path: '/aGapSucc/:token',
        name: 'aGapSucc',
        component: () => import('@/views/aGap/aGapSucc'),
    },
    {
        path: '/aGapCancel/:token',
        name: 'aGapCancel',
        component: () => import('@/views/aGap/aGapCancel'),
    },
    {
        path: '/maxMenu',
        name: 'maxMenu',
        component: () => import('@/views/maxPay/maxMenu'),
    },
    {
        path: '/maxRes/:token/:content_id/:content_type',
        name: 'maxRes',
        component: () => import('@/views/maxPay/maxRes')
    },
    {
        path: '/testBut',
        name: 'testBut',
        component: () => import('@/views/test/testBut'),
    },

    // 其他路由配置...
    {
        path: '/:pathMatch(.*)*', // Vue Router 4 的通配符语法
        redirect: '/', // 重定向到首页
    },
    {
        path: '/',
        name: 'emptyIndex',
        component: () => import('@/views/empty/emptyIndex'),
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes: routes
});

export default router;
